import { Trans } from '@lingui/react/macro';
import { Typography } from '@remarkable/ark-web';

import { ComponentLocations } from 'src/analytics/trackingTypes';
import { Button, FlexDivider } from 'src/components';
import { PromotionCheckoutLink } from 'src/components/PromotionCheckoutLink';
import { URLS } from 'src/utils/urls/urls';

export const NoSubscriptionNotPairedDeviceCard = () => (
  <div data-cy="subscription-no-plan-no-paired-device">
    <div className="flex flex-col gap-32 lm:flex-row">
      <div className="flex flex-1 flex-col justify-between gap-24">
        <Typography variant="body-sm" className="my-0">
          <Trans>
            If your reMarkable was purchased
            <Typography variant="body-sm" fontWeight="bold" as="strong">
              after November 7th, 2022
            </Typography>
            , simply pair your device and follow the steps to activate your
            Connect trial.
          </Trans>
        </Typography>

        <Button
          data-cy="pair-device-button"
          as="a"
          variant="primary"
          to={URLS.DEVICE_REMARKABLE_CONNECT}
          className="cursor-pointer"
        >
          <Trans>Pair your device</Trans>
        </Button>
      </div>

      <FlexDivider />

      <div className="flex flex-1 flex-col justify-between gap-24">
        <Typography variant="body-sm" className="my-0">
          <Trans>
            If you want to subscribe to Connect without a trial, you can do so
            here:
          </Trans>
        </Typography>

        <div className="flex flex-wrap items-center gap-24">
          <Button
            as="a"
            to={URLS.STORE_CONNECT_LANDING}
            variant="secondary"
            data-cy="buy-connect"
            className="cursor-pointer"
          >
            <Trans>Get Connect</Trans>
          </Button>
          <PromotionCheckoutLink
            componentLocation={ComponentLocations.SUBSCRIPTION.PLAN_PAGE}
          />
        </div>
      </div>
    </div>
  </div>
);
